// Module
var code = "<section class=\"blog-list\"> </section>";
// Exports
export default code;